import { logacyAppUrl } from '@/helpers/environment-variables';

export const initialData = () => ({
  userInfo: {},
  qaimConfig: {},
  sideNav: {
    collapsed: false,
    data: [],
    activeItem: {
      id: null,
      name: null,
      activeSubMenu: {
        id: null,
        name: null,
      },
    },
  },
  dataGrid: {
    httpRequestCancelCallbacks: [],
    filters: [],
    actions: [],
    columns: [],
    searchQuery: {
      fields: [],
      filters: [],
      paging: {
        pageIndex: 0,
        pageSize: 10,
      },
      sorting: {},
    },
    items: [],
    skipCastingEnabled: false,
    skipCastingKeys: [],
    total: 0,
  },
});

export default {
  appSettings: {
    color: 'green-sys',
    size: 'big-sys',
    scheme: 'dark-sys',
  },
  logacyAppUrl,
  userInfo: initialData().userInfo,
  qaimConfig: initialData().qaimConfig,
  sideNav: initialData().sideNav,
  dataGrid: initialData().dataGrid,
  appLoader: {
    visibility: false,
    color: '#0a9378',
  },
  overlayLoader: { visibility: false },
  breadcrumbs: {
    activeItem: null,
    params: {},
    data: [],
  },
  dynamicForms: [],
  dynamicGrids: [],
  pickLists: [],
};

//  {
//       id: 2,
//       name: 'formWithSections',
//       label: 'form with section',
//       description: 'form form',
//       isCustom: false,
//       customComponentName: null,
//       fields: [
//         {
//           id: 122,
//           typeId: 11,
//           type: 11,
//           name: 'sectionOne',
//           label: 'section one',
//           columnSize: 12,
//           sortIndex: 1,
//           properties: { validations: {} },
//           description: 'description',
//           fields: [
//             {
//               id: 123,
//               typeId: 1,
//               type: 1,
//               name: 'textField1',
//               label: 'text fiels',
//               columnSize: 3,
//               sortIndex: 2,
//               properties: { validations: {} },
//               description: 'asdfdasd',
//               fields: null,
//             },
//             {
//               id: 1230,
//               typeId: 1,
//               type: 1,
//               name: 'textField11',
//               label: 'text fiels 11',
//               columnSize: 6,
//               sortIndex: 2,
//               properties: { validations: {} },
//               description: 'asdfdasd',
//               fields: null,
//             },
//             {
//               id: 1231,
//               typeId: 1,
//               type: 1,
//               name: 'textField111',
//               label: 'text fiels 111',
//               columnSize: 5,
//               sortIndex: 2,
//               properties: { validations: {} },
//               description: 'asdfdasd',
//               fields: null,
//             },
//             {
//               id: 10,
//               name: 'input10',
//               label: 'الابناء',
//               typeId: 22,
//               columnSize: 12,
//               dataSource: [],
//               properties: {
//                 validations: { required: true },
//                 if: 'obj.textField111 == 1',
//                 dataGridConfig: {
//                   actions: [
//                     {
//                       actionType: 6,
//                       httpMethod: null,
//                       actionName: 'إضافة',
//                       url: '',
//                       params: {},
//                       permissionId: 2077,
//                       properties: { icon: null, tooltip: null, params: {} },
//                     },
//                     {
//                       actionType: 7,
//                       httpMethod: null,
//                       actionName: 'تعديل',
//                       url: '',
//                       params: {},
//                       permissionId: 2077,
//                       properties: { icon: null, tooltip: null, params: {} },
//                     },
//                     {
//                       actionType: 8,
//                       httpMethod: null,
//                       actionName: 'حذف',
//                       url: '',
//                       params: {},
//                       permissionId: 2077,
//                       properties: { icon: null, tooltip: null, params: {} },
//                     },
//                     {
//                       actionType: 9,
//                       httpMethod: null,
//                       actionName: 'معاينة',
//                       url: '',
//                       params: {},
//                       permissionId: 2077,
//                       properties: { icon: null, tooltip: null, params: {} },
//                     },
//                   ],
//                   fields: [
//                     {
//                       id: 2232,
//                       name: 'sonName',
//                       label: 'اسم الإبن',
//                       typeId: 1,
//                       dataSource: [],
//                       properties: { validations: { required: true } },
//                     },
//                     {
//                       id: 2233,
//                       name: 'birthDate',
//                       label: 'تاريخ الميلاد',
//                       typeId: 3,
//                       dataSource: [],
//                       properties: { validations: { required: true } },
//                     },
//                   ],
//                   headers: [
//                     {
//                       nodeId: 0,
//                       value: 'sonName',
//                       text: 'اسم الإبن',
//                       order: 1,
//                       isHidden: null,
//                       isSortAllowed: null,
//                       actionType: 0,
//                       httpMethod: 0,
//                       actionName: null,
//                       permissionId: null,
//                     },
//                     {
//                       nodeId: 0,
//                       value: 'birthDate',
//                       text: 'تاريخ الميلاد',
//                       order: 3,
//                       isHidden: null,
//                       isSortAllowed: null,
//                       actionType: 0,
//                       httpMethod: 0,
//                       actionName: null,
//                       permissionId: null,
//                     },
//                   ],
//                   pageIndex: 0,
//                   pageSize: 10,
//                   totalCount: 3916,
//                   totalPages: 392,
//                   hasPreviousPage: false,
//                   hasNextPage: true,
//                 },
//               },
//             },
//             {
//               id: 1255,
//               typeId: 1,
//               type: 1,
//               name: 'textField2',
//               label: 'text fiels',
//               columnSize: 5,
//               sortIndex: 2,
//               properties: { validations: {} },
//               description: 'asdfdasd',
//               fields: null,
//             },
//           ],
//         },
//         {
//           id: 123,
//           typeId: 1,
//           type: 1,
//           name: 'textField',
//           label: 'text fiels',
//           columnSize: 5,
//           sortIndex: 2,
//           properties: { validations: {} },
//           description: 'asdfdasd',
//           fields: [],
//         },
//       ],
//     },
